import config from 'src/config';
import api from 'src/services/httpService';
import storage from 'src/storage';

const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${storage.getToken()}`
  }
});

class Support {
  // Ticket inbox, optionally filtered by status (open | awaiting_user | resolved)
  static getTickets(status) {
    const query = status ? `?status=${status}` : '';
    return api.get(
      `${config.rootUrl}/admin/support/tickets${query}`,
      authConfig()
    );
  }

  // A single ticket with its full conversation
  static getTicket(id) {
    return api.get(
      `${config.rootUrl}/admin/support/tickets/${id}`,
      authConfig()
    );
  }

  // Reply to a ticket (-> Awaiting User + emails the requester)
  static reply(id, text) {
    return api.post(
      `${config.rootUrl}/admin/support/tickets/${id}/reply`,
      { text },
      authConfig()
    );
  }

  // Resolve a ticket
  static close(id) {
    return api.patch(
      `${config.rootUrl}/admin/support/tickets/${id}/close`,
      null,
      authConfig()
    );
  }
}

export default Support;
